<!-- AZIONI TOOLBAR -->
<section class="toolbar-action">
  <button mat-icon-button [matMenuTriggerFor]="psaMenu" class="ml-auto center-horizontally">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #psaMenu="matMenu">
    <!-- Delete interconnection -->
    <button mat-menu-item *ngIf="psaObject?.type === 'interconnessione'" (click)="deleteInterconnection()">
      <mat-icon color="warn">delete</mat-icon>
      {{ 'map.sidebar.psa.actions.delete_interconnection' | translate }}
    </button>
    <!-- Create interconnection -->
    <button mat-menu-item *ngIf="psaObject?.type !== 'interconnessione'" (click)="openCreateInterconnectionPanel()">
      <mat-icon>share</mat-icon>
      {{ 'map.sidebar.psa.actions.create_interconnection' | translate }}
    </button>
    <!-- Modify node -->
    <button mat-menu-item *ngIf="psaObject?.type === 'nodo'" (click)="modifyNode()">
      <mat-icon color="accent">edit</mat-icon>
      {{ 'map.sidebar.psa.actions.modify_node' | translate }}
    </button>
    <!-- Delete node -->
    <button mat-menu-item *ngIf="psaObject?.type === 'nodo'" (click)="deleteNode()">
      <mat-icon color="warn">delete</mat-icon>
      {{ 'map.sidebar.psa.actions.delete_node' | translate }}
    </button>
    <mat-divider></mat-divider>
    <!-- Documents -->
    <button mat-menu-item (click)="openElementFileSystem()">
      <mat-icon>inventory</mat-icon>
      {{ 'map.sidebar.psa.documents' | translate }}
    </button>
  </mat-menu>
</section>

<div class="overflow-hidden">
  <!-- INFO AVANZAMENTO E INDICE RISCHIO -->
  <div class="general-info">
    <div class="kpi-row">
      <div class="kpi-card">
        <div class="kpi-header">
          <div class="kpi-header-left">
            <span class="kpi-icon-badge">
              <mat-icon>trending_up</mat-icon>
            </span>
            <span class="kpi-title">{{ 'map.sidebar.psa.detail.stato_avanzamento_label' | translate }}</span>
          </div>
          <mat-icon class="kpi-info" matTooltip="{{ 'map.sidebar.psa.detail.stato_avanzamento_info_tooltip' | translate }}">info_outline</mat-icon>
        </div>
        <div class="kpi-value">{{ percentuale_avanzamento ? percentuale_avanzamento : 0 }}%</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-header">
          <div class="kpi-header-left">
            <span class="kpi-icon-badge">
              <mat-icon>warning_amber</mat-icon>
            </span>
            <span class="kpi-title">{{ 'map.sidebar.psa.detail.indice_rischio_label' | translate }}</span>
          </div>
          <mat-icon class="kpi-info" matTooltip="{{ 'map.sidebar.psa.detail.indice_rischio_info_tooltip' | translate }}">info_outline</mat-icon>
        </div>
        <div class="kpi-value">{{ indice_rischio ? indice_rischio : 0 }}</div>
      </div>
    </div>

    <!-- Compila Checklist / Matrice di Rischio — spostati fuori dal menu a 3 puntini -->
    <div class="actions-row">
      <button mat-stroked-button color="primary" *ngIf="hasChecklist" (click)="goToCheckList()">
        <mat-icon>fact_check</mat-icon>
        {{ 'map.sidebar.psa.actions.check_list' | translate }}
      </button>

      <button mat-stroked-button color="primary" (click)="updateBulkMatriceRischio()">
        <mat-icon>grid_on</mat-icon>
        {{ 'map.sidebar.psa.actions.matrice_rischio.label' | translate }}
      </button>
    </div>
  </div>
</div>
